module.exports = __webpack_public_path__ + "static/img/video-pass-off.adfa597e.png";